export const GEO_GENERAL = [
    'GEOTIMIZE:CNPJ',
];